(() => {
  if (window.iiBakhoorShopLoaded) return;
  window.iiBakhoorShopLoaded = true;
  const root = document.querySelector('[data-bkh-collection]');
  if (root) {
    const cards = [...root.querySelectorAll('[data-bkh-card]')];
    const groups = [...root.querySelectorAll('[data-bkh-group]')];
    cards.forEach((card, index) => { card.dataset.originalOrder = index; });
    const filter = () => {
      const term = root.querySelector('#bkh-search').value.trim().toLowerCase();
      const sort = root.querySelector('#bkh-sort').value;
      let matches = 0;
      cards.forEach(card => {
        const variants = JSON.parse(card.querySelector('[data-bkh-variants]').textContent);
        card.hidden = !`${card.dataset.title} ${variants.map(v => v.title).join(' ')}`.toLowerCase().includes(term);
        if (!card.hidden) matches++;
      });
      groups.forEach(group => {
        const grid = group.querySelector('.bkh-grid');
        const items = cards.filter(card => grid.contains(card));
        items.sort((a,b) => sort === 'price-low' ? a.dataset.price-b.dataset.price : sort === 'price-high' ? b.dataset.price-a.dataset.price : sort === 'name' ? a.dataset.title.localeCompare(b.dataset.title) : a.dataset.originalOrder-b.dataset.originalOrder);
        const extra = grid.querySelector('.bkh-accessory-copy');
        items.forEach(card => grid.insertBefore(card, extra));
        group.hidden = !items.some(card => !card.hidden);
      });
      root.querySelector('.bkh-empty').hidden = matches > 0;
      root.querySelector('[data-bkh-status]').textContent = `${matches} matching designs`;
    };
    root.querySelector('#bkh-search').addEventListener('input', filter);
    root.querySelector('#bkh-sort').addEventListener('change', filter);
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-bkh-variant]');
      if (!button) return;
      const card = button.closest('[data-bkh-card]');
      const variant = JSON.parse(card.querySelector('[data-bkh-variants]').textContent).find(v => String(v.id) === button.dataset.bkhVariant);
      if (!variant?.available) return;
      const image = card.querySelector('.bkh-media img');
      image.src = variant.image;
      image.removeAttribute('srcset');
      image.alt = `${card.dataset.title} in ${variant.title}`;
      card.querySelectorAll('[data-bkh-link]').forEach(link => { link.href = variant.url; });
      card.querySelector('input[name="id"]').value = variant.id;
      card.querySelector('[name="add"]').setAttribute('aria-label', `Add ${card.dataset.title} in ${variant.title} to basket`);
      card.querySelectorAll('[data-bkh-variant]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
      const price = card.querySelector('[data-bkh-price]');
      price.replaceChildren();
      if (variant.compare > variant.price) {
        const original = document.createElement('s');
        original.textContent = variant.compareMoney;
        price.append(original, ' ');
      }
      price.append(document.createTextNode(variant.money));
      card.dataset.price = variant.price;
      root.querySelector('[data-bkh-status]').textContent = `${card.dataset.title}, ${variant.title}, ${variant.money}`;
    });
    root.querySelectorAll('block-buy-buttons').forEach(component => component.addEventListener('submit', event => {
      if (!customElements.get('block-buy-buttons')) return;
      const card = component.closest('[data-bkh-card]');
      card.querySelectorAll('[data-bkh-variant]').forEach(button => { button.disabled = true; });
      const add = component.querySelector('[name="add"]');
      const observer = new MutationObserver(() => {
        if (!add.classList.contains('btn--loading')) {
          card.querySelectorAll('[data-bkh-variant]').forEach(button => { button.disabled = false; });
          observer.disconnect();
        }
      });
      observer.observe(add, {attributes:true, attributeFilter:['class']});
    }));
  }
  const pdp = document.querySelector('[data-bkh-pdp]');
  if (pdp) {
    const gallery = pdp.querySelector('product-images');
    const syncGallery = variant => {
      if (!variant?.featured_media?.id || !gallery) return;
      requestAnimationFrame(() => {
        const slider = gallery.flickity?.slideshow;
        const index = slider?.cells?.findIndex(cell => cell.element.dataset.mediaId === String(variant.featured_media.id));
        if (index >= 0) slider.select(index, false, true);
      });
    };
    document.addEventListener(`variant:change:${pdp.dataset.bkhSection}:${pdp.dataset.bkhProduct}`, event => {
      if (!event.detail.loading) syncGallery(event.detail.variant);
    });
    customElements.whenDefined('product-images').then(() => {
      const data = gallery?.querySelector('[data-current-variant-json]');
      if (data) syncGallery(JSON.parse(data.textContent));
    });
    const form = pdp.querySelector('block-buy-buttons form');
    const add = form?.querySelector('[name="add"]');
    const sticky = pdp.querySelector('[data-bkh-sticky]');
    if (!form || !add || !sticky) return;
    const stickyAdd = sticky.querySelector('button');
    const update = () => {
      sticky.hidden = innerWidth > 640 || add.getBoundingClientRect().bottom >= 0 || pdp.getBoundingClientRect().bottom < 100;
      stickyAdd.disabled = add.disabled || add.classList.contains('btn--loading');
      stickyAdd.textContent = add.disabled ? 'Sold out' : 'Add to basket';
      const prices = [...pdp.querySelectorAll('block-price .element-price')].filter(el => el.getBoundingClientRect().height && !el.closest('s'));
      const price = prices.at(-1);
      if (price) {
        const copy = price.cloneNode(true);
        copy.querySelectorAll('sup').forEach(sup => sup.replaceWith(document.createTextNode(`.${sup.textContent}`)));
        sticky.querySelector('[data-bkh-sticky-price]').textContent = copy.textContent.trim();
      }
      const selected = [...pdp.querySelectorAll('block-variant-picker input:checked')].map(input => input.value).join(' / ');
      if (selected) sticky.querySelector('[data-bkh-sticky-option]').textContent = selected;
    };
    stickyAdd.addEventListener('click', () => { if (!add.disabled) form.requestSubmit(add); });
    addEventListener('scroll', update, {passive:true});
    addEventListener('resize', update, {passive:true});
    new MutationObserver(update).observe(pdp.querySelector('.product-single__meta'), {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','class','checked']});
    update();
  }
})();
